<script>
export default {
  name: "zlifepet-aplicar-diagnostico",

  inject: ["hdl"],

  data() {
    return {
      aplicacao: "definitivo",
    };
  },

  props: {
    diagnostico: {
      type: String,
    },
    visible: {
      type: Boolean,
      required: true,
    },
  },
  emits: ["close", "aplicar"],
};
</script>

<template>
  <s-janela :dad="hdl" title="Escolher aplicação do diagnóstico"
    :visible="visible" :width="450" :height="250" @close="$emit('close')">
    <s-layout>
      <div class="s-card">
        <p style="margin-bottom: 16px">
          <label>Diagnóstico selecionado:</label>
          <b style="font-size: 12px">{{diagnostico}}</b>
        </p>
        <label for="aplicar-select" style="margin-bottom: 4px">
          Escolha como o diagnóstico selecionado deve ser aplicado:</label>
        <select id="aplicar-select" v-model="aplicacao" style="width: 100%">
          <option value="definitivo">Diagnóstico definitivo</option>
          <option value="suspeito">Diagnóstico suspeito</option>
        </select>
      </div>
      <template v-slot:footer>
        <button type="button" @click="$emit('close')">Cancelar</button>
        <button type="button" class="btn-primary"
          @click="$emit('aplicar', aplicacao)"><i
            class="mdi mdi-content-save-outline mdi-18px">Aplicar</i></button>
      </template>
    </s-layout>
  </s-janela>
</template>